// export const getStyles = (style) => {

//     let resolution    = typeof window == 'object' ? window.innerWidth : 1300;
//     let isMobile      = resolution >= 320 && resolution <= 576;
//     let isTablet      = resolution >= 577 && resolution <= 1024;

//     if(typeof style === 'object')
//     {
//         let obj = {}
//         obj = {...style}
//         obj['paddingLeft'] = isMobile || isTablet ? 0 : style?.paddingLeft
//         obj['paddingRight'] = isMobile || isTablet ? 0 : style?.paddingRight

//         if(isMobile)
//         {
//             obj['fontSize'] = style?.fontSize / 2
//         }

//         return obj
//     }

//     return style

// }


export const getStyles = (style) => {

    let resolution    = typeof window == 'object' ? window.innerWidth : 1300;
    let isMobile      = resolution >= 320 && resolution <= 576;
    let isTablet      = resolution >= 577 && resolution <= 1024;

    if(typeof style === 'object')
    {
        let obj = {}
            obj = {...style} 

        const maxWidthMap =   {
                                    0: 2000,
                                    60: 1600,
                                    120: 1400,
                                    240: 1200,
                                    380: 991,
                                };

        const maxScreenWidth = maxWidthMap[style?.paddingRight] ?? 1200;

  // If full width
        if (maxScreenWidth === 2000)
        {
             obj['paddingLeft'] =  2;
             obj['paddingRight'] =  2;
        }
        else
        {
            obj['paddingLeft'] =  Math.max((window.innerWidth - maxScreenWidth) / 2, 8);
            obj['paddingRight'] =  Math.max((window.innerWidth - maxScreenWidth) / 2, 8);
        }

        
        if(isMobile)
        {
            obj['fontSize'] = style?.fontSize / 2
        }

        return obj
    }

    return style

}